import { render, staticRenderFns } from "./treatmentpartquantity.vue?vue&type=template&id=5e26a802"
import script from "./treatmentpartquantity.vue?vue&type=script&lang=js"
export * from "./treatmentpartquantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e26a802')) {
      api.createRecord('5e26a802', component.options)
    } else {
      api.reload('5e26a802', component.options)
    }
    module.hot.accept("./treatmentpartquantity.vue?vue&type=template&id=5e26a802", function () {
      api.rerender('5e26a802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/treatmentpartquantity.vue"
export default component.exports